module.exports = __webpack_public_path__ + "assets/img/banner1.f424fb8d.jpg";